import './styles.less'

export default function TagCell({ rowData, dataKey, bgColor, color, ...props }) {
  return (
    <div
      className="tag"
      style={{
        backgroundColor: bgColor || '',
        height: '100%',
      }}
      {...props}
    >
      <span className="tag__text" style={{ color: color }}>
        {rowData[dataKey]}
      </span>
    </div>
  )
}
